export * from './TriangleFilled';